"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsKey = exports.ModSocialNetwork = exports.NamespaceType = exports.SupportedType = void 0;
var SupportedType;
(function (SupportedType) {
    SupportedType["NONE"] = "NONE";
    SupportedType["MOD"] = "MOD";
    SupportedType["MOD_STAGING"] = "MOD_STAGING";
})(SupportedType = exports.SupportedType || (exports.SupportedType = {}));
var NamespaceType;
(function (NamespaceType) {
    NamespaceType["PUBLIC"] = "PUBLIC";
    NamespaceType["PRIVATE"] = "PRIVATE";
})(NamespaceType = exports.NamespaceType || (exports.NamespaceType = {}));
var ModSocialNetwork;
(function (ModSocialNetwork) {
    ModSocialNetwork["Twitter"] = "twitter";
    ModSocialNetwork["Facebook"] = "facebook";
    ModSocialNetwork["Twitch"] = "twitch";
    ModSocialNetwork["Discord"] = "discord";
    ModSocialNetwork["Instagram"] = "instagram";
    ModSocialNetwork["VKontakte"] = "vKontakte";
    ModSocialNetwork["YouTube"] = "youTube";
    ModSocialNetwork["Naver"] = "naver";
    ModSocialNetwork["Youku"] = "youku";
    ModSocialNetwork["Weibo"] = "weibo";
    ModSocialNetwork["Reddit"] = "reddit";
})(ModSocialNetwork = exports.ModSocialNetwork || (exports.ModSocialNetwork = {}));
var SettingsKey;
(function (SettingsKey) {
    SettingsKey["BINARY_VALIDATION_MAX_ALLOWED_SIZE_BYTES"] = "BINARY_VALIDATION_MAX_ALLOWED_SIZE_BYTES";
    SettingsKey["BINARY_VALIDATION_FILE_TYPE_BLACKLIST"] = "BINARY_VALIDATION_FILE_TYPE_BLACKLIST";
    SettingsKey["ENABLE_PLATFORMS_SELECTION_FOR_GAME"] = "ENABLE_PLATFORMS_SELECTION_FOR_GAME";
    SettingsKey["SUSPEND_MODDING"] = "SUSPEND_MODDING";
})(SettingsKey = exports.SettingsKey || (exports.SettingsKey = {}));
//# sourceMappingURL=mod.js.map